import type {StickyType} from '../interface';

export const stickyHeights: Record<StickyType, (cId?: string) => number> = {
    DESKTOP_HEADER: () => {
        const desktopHeader = document.querySelector('[data-gem-module-name="header"]');
        return desktopHeader?.clientHeight ?? 0;
    },
    MOBILE_HEADER: () => {
        const mobileHeader = document.querySelector('.mobile-header');
        return mobileHeader?.clientHeight ?? 0;
    },
    PWA_HEADER: () => document.querySelector('.js-pwa-header')?.clientHeight || 0,
    IN_PG_NAV: () => 71,
    FILTERS: () => 65,
    OTHER: () => 0,
    LAST: () => 0,
    POPUP: (cId?: string) => {
        if (!cId) {
            return 0;
        }

        const popupElement = document.querySelector(`[id="${cId}"]`);
        return popupElement?.clientHeight ?? 0;
    },
    STICKY_LINKS: () => {
        const stickyLinksElement = document.querySelector('.sticky-links');
        return stickyLinksElement?.clientHeight ?? 0;
    },
    AUDIO_PLAYER: () => 65,
    COMPARISON: (cId?: string) => {
        const compareWidgetWrapper = document.querySelector(`[id="${cId}__compare-widget"]`);
        return compareWidgetWrapper?.clientHeight ?? 0;
    },
    TABLE_STICKY_HEADER: (id) => {
        const arrowsNavigationHeight = document.querySelector(`[id="${id}-table-arrows-navigation"]`)?.clientHeight ?? 0;
        const tableHeaderRowHeight = document.querySelector(`[id="${id}-table-scroll-wrapper"] .table-header-row`)?.clientHeight ?? 50;

        return arrowsNavigationHeight + tableHeaderRowHeight;
    },
};
